import { render } from "./ProductCardComponent.vue?vue&type=template&id=30ecc3b4"
import script from "./ProductCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__